import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StaffItem } from '../../models/ydata.model';
import { RootSiblings } from '../../services/staff.service';

@Component({
  selector: 'app-reallocate-dialog',
  templateUrl: './reallocate-dialog.component.html',
  styleUrls: ['./reallocate-dialog.component.css']
})
export class ReallocateDialogComponent implements OnInit {
  shiftStaff: StaffItem[] = [];
  regularStaff: StaffItem[] = [];
  selectedShiftStaff: number | null = null;
  selectedRegularStaff: number | null = null;
  sourceStaffName: string = '';
  serviceCount: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ReallocateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      sourceStaffName: string;
      serviceCount: number;
      rootSiblings: RootSiblings;
    }
  ) {}

  ngOnInit() {
    this.shiftStaff = this.data.rootSiblings.shifts;
    this.regularStaff = this.data.rootSiblings.staff;
    this.sourceStaffName = this.data.sourceStaffName;
    this.serviceCount = this.data.serviceCount;
  }

  onShiftStaffSelected(staffKey: number) {
    this.selectedShiftStaff = staffKey;
    this.selectedRegularStaff = null; // Clear other selection
  }

  onRegularStaffSelected(staffKey: number) {
    this.selectedRegularStaff = staffKey;
    this.selectedShiftStaff = null; // Clear other selection
  }

  get hasSelection(): boolean {
    return this.selectedShiftStaff !== null || this.selectedRegularStaff !== null;
  }

  onConfirm() {
    let selectedStaffMember: StaffItem | undefined;
    
    if (this.selectedShiftStaff !== null) {
      selectedStaffMember = this.shiftStaff.find(staff => staff.key === this.selectedShiftStaff);
    } else if (this.selectedRegularStaff !== null) {
      selectedStaffMember = this.regularStaff.find(staff => staff.key === this.selectedRegularStaff);
    }

    if (selectedStaffMember) {
      this.dialogRef.close({
        confirmed: true,
        targetStaffId: selectedStaffMember.key.toString(),
        targetStaffName: selectedStaffMember.label
      });
    }
  }

  onCancel() {
    this.dialogRef.close({ confirmed: false });
  }
}
